<template>
    <div id="container" type="vhomeowner">
        <div class="page page-homeowner" v-ga:page="{pageType: glb.pageType, glb: glb}" v-ga:request="{pageType: glb.pageType}">
            <mvtHeader />
            <ownerWelcome></ownerWelcome>
            <ownerContent></ownerContent>
            <mvtFooter />
        </div>
        <mvtPopSignin />
        <mvtDialogCenter></mvtDialogCenter>
    </div>
</template>

<script src="./page-homeowner.js"></script>
